// extracted by mini-css-extract-plugin
module.exports = {"header__cell":"header__cell-f5GwO","details":"details-3SqaI"};